import React, {PropTypes as T} from 'react';
import Button from '../../common/button';
import translate from '../../../utils/translate';
import TU from '../../common/tu';
import Modal, {ModalHeader, ModalContent, ModalFooter} from '../../common/modal';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';
import ModalCloseIcon from '../../common/icons/icon_close2';

export default class EventTicketLimit extends React.Component {
  static propTypes = {
    onClickOutside: T.func.isRequired,
    ticketLimit: T.number.isRequired,
    title: T.string.isRequired
  };

  render () {
    return (
      <Modal
        dataComponent="notification-message"
        isOpen
        onClose={this.props.onClickOutside}>
        <ModalHeader isWarning>
          <div className="modal__header__icon__wrapper">
            <ModalCautionIcon className="modal__header__icon--dark" />
          </div>
          <div className="modal__header_title">{this.props.title}</div>
          <Button icon onClick={this.props.onClickOutside} data-component="modal__close_button">
            <ModalCloseIcon className="modal__header__close_icon--dark" />
          </Button>
        </ModalHeader>
        <ModalContent>
          <TU
            text={translate('pageTranslations', 'CART_FULL_MESSAGE', {'%MAX_TICKETS%': this.props.ticketLimit})}
            tag="div" />
        </ModalContent>
        <ModalFooter>
          <Button
            primary
            data-component="modal__cta"
            onClick={this.props.onClickOutside}>
            {translate('pageTranslations', 'OK')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/event_ticket_limit.js